export default __webpack_public_path__ + "static/media/error-404.ae1fcc20.png";